import { type FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { ModalContext } from '@/components/Modals/Modal/config';
import { SecondaryButton } from '@/components/ui/Button/Button';

const LaterButton: FC = () => {
  const { closeModal } = useContext(ModalContext);
  const { t } = useTranslation();

  return (
    <SecondaryButton
      className={'flex-1 !w-auto'}
      onClick={closeModal}
      text={t('Later')}
    />
  );
};

export { LaterButton };
